!function() {
  "use strict";
  customElements.get("product-detail-label") || customElements.define("product-detail-label", class extends HTMLElement {
    constructor() {
      super(), this.label = this.querySelector("label"), this.modal = null, this.handleClick = this.handleClick.bind(this);
    }
    getItemId() {
      try {
        let t = (this.closest("[data-product]") || this.closest(".shopify-section")).querySelector('form[action*="/cart/add"] [name="id"]');
        if (t) return t.dataset.variantSku || t.value;
        if (t = document.querySelector('form[action*="/cart/add"] [name="id"]'), t) return t.dataset.variantSku || t.value;
        const e = document.querySelector("product-form[data-product-id]");
        return e ? e.getAttribute("data-product-id") : "";
      } catch (t) {
        return "";
      }
    }
    getProductId() {
      try {
        const t = document.querySelector("product-form[data-product-id]");
        return t ? t.getAttribute("data-product-id") : "";
      } catch (t) {
        return "";
      }
    }
    getProductTitle() {
      try {
        const t = document.querySelector("product-scroll[data-product-title]");
        return t ? t.getAttribute("data-product-title") : "";
      } catch (t) {
        return "";
      }
    }
    handleClick(t) {
      const e = this.label.getAttribute("data-key"), a = document.getElementById(`${e}`);
      a && a.click();
      try {
        if ("product" === document.body.getAttribute("data-template")) {
          const t = this.label ? this.label.textContent.trim() : null, e = this.getItemId(), a = this.getProductId(), c = this.getProductTitle();
          window.dataLayer = window.dataLayer || [], window.dataLayer.push({
            event: "select_content",
            content_type: "pdp_information",
            item_id: e,
            item_name: c,
            product_id: a,
            faq_question: t,
            page_section: "main-content",
            page_type: "pdp"
          });
        }
      } catch (t) {
        console.warn("GTM Error in product-detail-label:", t);
      }
    }
    connectedCallback() {
      if (!this.label) return;
      this.label.addEventListener("click", this.handleClick);
      const t = this.label.getAttribute("for");
      this.modalEl = document.getElementById(t);
      const e = new URLSearchParams(window.location.search), a = e.get("product-detail-label-key");
      if (a) {
        e.delete("product-detail-label-key");
        const t = e.toString() ? `${window.location.pathname}?${e.toString()}` : window.location.pathname;
        window.history.replaceState({}, "", t), this.modalEl && this.modalEl.click();
        const c = document.getElementById(a);
        c && c.click();
      }
    }
    disconnectedCallback() {
      this.label && this.label.removeEventListener("click", this.handleClick);
    }
  });
}();